import React, {useState} from "react";
import _ from "lodash";
import {DatePicker, Selector} from "../../../components";
import FieldOptionsSelector from "./FieldOptionsSelector";
import MultiLineField from "./MultiLineField";
import SingleLineField from "./SingleLineField";
import UrlField from "./UrlField";
import ImageField from "./ImageField";
import DateField from "./DateField";
import IntegerField from "./IntegerField";
import HoursField from "./HoursField"
import BooleanField from "./BooleanField";

/**
 *   case class LocalPageSection(
 sectionId: String,
 sectionDisplayName: String,
 required: Boolean = false,
 active: Boolean = true,
 custom: Boolean = false,
 isBooleanCollection: Boolean = false,
 notes: String = "",
 fields: List[LocalPageField] = List()
 )
 */

/**
 *
 * @param section  The section we are rendering the UI for
 * @param singleLocationMode  Editing one location or more than one location
 * @param locationPatch  a structure to track the content changes
 * @returns {JSX.Element}
 * @constructor
 */
function ContentSection({section, singleLocationMode, locationPatch, setFormIsDirty, readOnly}) {
    const [fields, setFields] = useState(section.fields)
    const [sectionPatch, setSectionPatch] = useState({...section, fields: []})

    const updatePatch = () => {
        const dirtyFields = fields.filter(field => field.dirty).map(field => _.omit(field,'dirty'))
        sectionPatch.fields = dirtyFields
        // setSectionPatch(sectionPatch)
        const maybeSectionPatch = locationPatch.localPages.localPagesContent.templateFieldsAndSections.find(s => {
            return s.sectionId === section.sectionId
        })
        //If the section isn't already in the locationPatch add it
        if(!maybeSectionPatch){
            const sectionsAlreadyOnPatch = [...locationPatch.localPages.localPagesContent.templateFieldsAndSections]
            sectionsAlreadyOnPatch.push(sectionPatch)
            locationPatch.localPages.localPagesContent.templateFieldsAndSections=sectionsAlreadyOnPatch
        }

    }

    const fieldUpdated = (fieldObj) => {
        fieldObj.dirty=true
        updatePatch()
        setFormIsDirty(true)
    }

    return (!!section.active && <div>
        <div className="row">
            <div className="col-3 mt-3">
                <h5>{section.sectionDisplayName}</h5>
            </div>
            <div className="col-sm mt-3">
                {section.notes}
            </div>
        </div>
        {fields.map((field, index) => {
            return <div key={"div-1-" + field.fieldId + index} className="mt-2">
                {field.fieldType === "TextSingleLine" && <div className="row">
                    <div className="col">
                        <SingleLineField
                            key={"SingleLineInput -" + field.fieldId + index}
                            fieldObj={field}
                            fieldIndex={index}
                            fieldUpdatedFunction={fieldUpdated}
                            singleLocationMode={singleLocationMode}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                }
                {field.fieldType === "Url" && <div className="row">
                    <div className="col">
                        <UrlField
                            key={"UrlInput -" + field.fieldId + index}
                            fieldObj={field}
                            fieldIndex={index}
                            fieldUpdatedFunction={fieldUpdated}
                            singleLocationMode={singleLocationMode}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                }
                {field.fieldType === "PdfUrl" && <div className="row">
                    <div className="col">
                        <UrlField
                            key={"PdfUrlInput -" + field.fieldId + index}
                            fieldObj={field}
                            fieldIndex={index}
                            fieldUpdatedFunction={fieldUpdated}
                            singleLocationMode={singleLocationMode}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                }
                {field.fieldType === "TextMultiLine" && <div className="row">
                    <div className="col">
                        <MultiLineField
                            key={"input -" + field.fieldId + index}
                            fieldObj={field}
                            fieldIndex={index}
                            fieldUpdatedFunction={fieldUpdated}
                            singleLocationMode={singleLocationMode}
                            readOnly = {readOnly}
                        />
                    </div>
                </div>
                }
                {field.fieldType === "SingleSelect" && <div className="row">
                    <FieldOptionsSelector
                        key={"SingleSelectField-" + index}
                        fieldObj={field}
                        fieldIndex={index}
                        fieldUpdatedFunction={fieldUpdated}
                        singleLocationMode={singleLocationMode}
                        multi={false}
                        readOnly={readOnly}
                    />
                </div>
                }
                {field.fieldType === "MultiSelect" && <div className="row">
                    <FieldOptionsSelector
                        key={"MultiSelectField-" + index}
                        fieldObj={field}
                        fieldIndex={index}
                        fieldUpdatedFunction={fieldUpdated}
                        singleLocationMode={singleLocationMode}
                        multi={true}
                        readOnly={readOnly}
                    />
                </div>
                }
                {field.fieldType === "ImageUrl" && <div className="row">
                    <ImageField
                        key={"ImageField-" + index}
                        fieldObj={field}
                        fieldIndex={index}
                        fieldUpdatedFunction={fieldUpdated}
                        singleLocationMode={singleLocationMode}
                        readOnly={readOnly}
                    />
                </div>
                }
                {field.fieldType === "DatePicker" && <div className="row">
                    <div className="col">
                        <DateField
                            key={"DateField-" + index}
                            fieldObj={field}
                            fieldIndex={index}
                            fieldUpdatedFunction={fieldUpdated}
                            singleLocationMode={singleLocationMode}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                }
                {field.fieldType === "Integer" && <div className="row">
                    <div className="col">
                        <IntegerField
                            key={"IntegerField-" + index}
                            fieldObj={field}
                            fieldIndex={index}
                            fieldUpdatedFunction={fieldUpdated}
                            singleLocationMode={singleLocationMode}
                            readOnly={readOnly}
                        />
                    </div>
                </div>
                }
                {field.fieldType === "HoursSet" && <div className="row">
                    <HoursField
                        key={"HoursField-" + index}
                        fieldObj={field}
                        fieldIndex={index}
                        fieldUpdatedFunction={fieldUpdated}
                        singleLocationMode={singleLocationMode}
                        readOnly={readOnly}
                    />
                </div>
                }
                {field.fieldType === "Boolean" && <div className="row">
                    <BooleanField
                        key={"BooleanField-" + index}
                        fieldObj={field}
                        fieldIndex={index}
                        fieldUpdatedFunction={fieldUpdated}
                        singleLocationMode={singleLocationMode}
                        readOnly={readOnly}
                    />
                </div>
                }
            </div>

        })}


    </div>)

}

export default ContentSection;